export function getMjerneJedinice(mjerneJedinice) {
    return { type: 'GET_MJERNE_JEDINICE', mjerneJedinice };
}
